export default function validPin() {
  'ngInject';

  return {
    require: 'ngModel',
    link($scope, $element, $attrs, $ctrl) {
      $ctrl.$validators['valid-pin'] = (model, view) => {
        if (!view) {
          return true;
        }

        const value = typeof view === 'string' ? view : String.toString(view);
        return value.length === 4 && value.match(/[0-9]/);
      };
    },
  };
}
